<template>
  <router-view />
  <v-dialog v-model="isDialogVisible.value" max-width="400">
    <v-card>
      <v-card-title>Error</v-card-title>
      <v-card-text>{{ errorMessage }}</v-card-text>
      <v-card-actions>
        <v-btn color="primary" text @click="isDialogVisible.value = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { errorMessage,isDialogVisible } from './composables/api_request';
import {defineComponent} from "vue";
import ErrorDialog from "./components/ErrorDialog.vue";

export default defineComponent({
  components: {ErrorDialog},
  computed: {
    errorMessage() {
      return errorMessage
    },
    isDialogVisible() {
      return isDialogVisible
    }
  }
})

</script>